<template>
  <div>
    <Loading v-if="!requested" />
    <TopNavbar :bgColor="'bg-main'" :class="isSubmit? 'hideVisibility':'showVisibility'">
      <van-icon name="arrow-left" class="icon" @click="arrowLeft" />
      <div class="flex1">
        <div class="flex justify-between">
          <div>Address List</div>
          <van-icon @click="addAddress" name="plus" size="23" />
        </div>
      </div>
    </TopNavbar>

    <ChooseFeature v-if="isSubmit" 
      :confirm="quotation"
      :cancel="cancelSave"
      :store="this.delivery_current_storeinfo"
      :serviceType="this.serviceType"
      :disableOption="disableOption" />

    <div class="container" v-if="requested" :class="isSubmit? 'hideVisibility':'showVisibility'">

      <div class="address-list" v-if="addressListData.length>0" :class="isSubmit? 'hideVisibility':'showVisibility'">
        <div v-for="(item, index) in addressListData" :key="index" :class="{'address-item':1, 'selected': current_address_id == item.address_id}">
          <div class="flex1" @click="chooseAddress(item)">
            <div class="address-data">
              <div class="address-info">
                {{item.name}}
                <span v-if="item.is_default" class="default-address">[Default]</span>
              </div>
              <div class="address-contact">
                <!-- <span class="contact-info">{{item.nickname}}</span>
              <span class="contact-info">{{item.mobile}}</span> -->
                <div>
                  <span v-if="item.address2">{{item.address2}}, </span>
                  <span v-if="item.address">{{item.address}}</span>
                </div>
              </div>
            </div>
          </div>
          <van-icon class="addresss-wapper" name="edit" size="20" @click="addressDetail(item)" />
        </div>
      </div>
    </div>

    <shipType :class="isSubmit? 'hideVisibility':'showVisibility'" :key="shipTypeKey" v-if="showShipType" :show="showShipType" :easypacel="easypacelList" @evtShipType="arrowLeft" />
  </div>
</template>

<script>
import { getAddressList, getDeliveryQuotation, getDeliveryOption } from '@/api/api'
import mockDemo from '@/api/mock'
import { cartMixin } from '@/mixins/cartMixin'
import { mapGetters, mapActions } from 'vuex'
import ChooseFeature from '@/components/common/ChooseFeature.vue'
import TopNavbar from '@/components/common/TopNavbar.vue'
import Loading from '@/components/common/Loading.vue'
import shipType from '../cart/shipType'
import { Dialog } from 'vant'

export default {
  name: 'addressList',
  components: { TopNavbar, Loading, shipType, ChooseFeature },
  data () {
    return {
      isSubmit: false,
      choosedAddress: {},
      requested: true,
      mobile: '', //用户表单的电话号码
      storeInfo: {},
      addressListData: [],
      current_address_id: 0,
      nickname: '', // 收餐人名字
      // ----------------  显示物流信息列表
      shipTypeKey: +new Date(),
      showShipType: false,
      disableOption: false,
      lalamoveList: {}, // lalamove 物流列表信息
      easypacelList: {}, // easypacel 物流列表信息
      serviceType: {}
    };
  },
  created () {
    const queryParams = this.$route.query
    if (this.delivery_current_address && this.delivery_current_address.address_id) {
      this.current_address_id = this.delivery_current_address.address_id
    }
    this.get_data()
    console.log(['检查登录状态', this.user_islogin, this.user_detail]);
  },
  computed: {
    ...mapGetters(["delivery_current_address", "delivery_current_storeinfo", "user_islogin", "user_detail"])
  },
  mixins: [cartMixin],
  methods: {
    ...mapActions({
      saveCurrentAddress: "delivery/settingCurrentAddress",
      saveLalamoveList: "delivery/settingLalamoveList",
      saveEasyparcel: "delivery/settingEasyparcel",
      saveTeleport: "delivery/settingTeleport",
      saveDelyva: "delivery/settingDelyva",
      saveTadago: "delivery/settingTadago",
    }),
    arrowLeft () {
      window.history.back(-1)
    },
    dialogMessage (text, isBack) {
      Dialog({
        message: text,
        confirmButtonText: 'Confirm'
      }).then(() => {
        if (isBack) {
          this.arrowLeft()
        }
      });
    },
    get_data () {
      this.requested = false
      const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'get_user_address_list' })
      getAddressList('/app/index.php', queryParams).then(res => {
        this.addressListData = res.data
        this.requested = true
      }).catch(error => {
        this.$toast('network timeout')
        this.requested = true
      })
    },
    chooseAddress (addressItem) {
      this.current_address_id = addressItem.address_id
      addressItem.nickname = addressItem.contactName
      addressItem.mobile = addressItem.contactMobileNumber
      console.log('marker location address',addressItem.lat, ' ',addressItem.lng)
      console.log('marker store >>>', this.delivery_current_storeinfo.location.lat,', ',this.delivery_current_storeinfo.location.lng)
      let distance = this.calcCrow(addressItem.lat,addressItem.lng,Number(this.delivery_current_storeinfo.location.lat),Number(this.delivery_current_storeinfo.location.lng)).toFixed(1);
      console.log('Distance between store and location',distance)
      if (distance > 20){
        this.disableOption = true;
      } else {
        this.disableOption = false;
      }
      console.log('选择了地址', addressItem, [this.current_address_id, addressItem.address_id]);
      const getOption = () => {
          const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'getDeliveryOption' })
          const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
          getDeliveryOption('/app/index.php?' + suffixQuery, {store: this.delivery_current_storeinfo})
              .then(res => {
                  this.serviceType = res.data.deliveryOption;
                  console.log('this.serviceType',this.serviceType)
                  if (this.delivery_current_storeinfo.is_rain == 1){
                      this.dialogMessage('The merchant is on raining mode. All the bike delivery service will be disabled and should be expecting some delay for the order',false)
                  }
                  if (this.serviceType.delivery_service == 'teleport'){
                      if (this.serviceType.service_type.length > 1){
                          this.saveCurrentAddress(this.choosedAddress);
                          this.requested = true;
                          this.isSubmit = true;
                      } else if (this.serviceType.service_type.length == 1){
                          if (this.serviceType.service_type[0] == 'STANDARD'){
                              this.serviceType.choosedService = 'STANDARD_24';
                          } else {
                              this.serviceType.choosedService = this.serviceType.service_type[0];
                          }
                          this.saveCurrentAddress(this.choosedAddress);
                          this.requested = false;
                          this.quotation();
                      }
                  } else if (this.serviceType.delivery_service == 'lalamove'){
                      if (this.serviceType.service_type.length > 1){
                          this.saveCurrentAddress(this.choosedAddress);
                          this.requested = true;
                          this.isSubmit = true;
                      } else if (this.serviceType.service_type.length == 1){
                          this.serviceType.choosedService = this.serviceType.service_type[0];
                          this.saveCurrentAddress(this.choosedAddress);
                          this.requested = false;
                          this.quotation();
                      }
                  } else {
                      this.saveCurrentAddress(this.choosedAddress);
                      this.requested = false;
                      this.quotation();
                  }
                  //this.quotation(addressItem)
              })
              .catch(error => {
                // console.log('添加到购物车.error', error);
              });
      };
      getOption();
      this.choosedAddress = addressItem
    },
    quotation () {
      this.saveCurrentAddress({})
      const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'get_delivery_quotation' })
      const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
      getDeliveryQuotation('/app/index.php?' + suffixQuery, {serviceType:this.serviceType , store: this.delivery_current_storeinfo, address: this.choosedAddress }).then(res => {
        this.choosedAddress['quotation'] = res.data
        this.requested = true
        this.isSubmit = false;
        
        if(res.data) {
              if (res.data.store_delivery_service_type === 1) {
                this.dialogMessage(res.msg, res.status)
              }
              if (res.data.store_delivery_service_type === 2) {
                this.dialogMessage(res.msg, res.status)
                this.saveLalamoveList(res.data.ship_data_list)
              }
              if (res.data.store_delivery_service_type === 3) {
                this.saveEasyparcel(res.data.ship_data_list)
                this.$router.push( { path: "/delivery/shipment", query: { "address_id": 0 } });
              }
              if (res.data.store_delivery_service_type === 5) {
                this.dialogMessage(res.msg, res.status)
              }
              if (res.data.store_delivery_service_type === 6) {
                this.dialogMessage(res.msg, res.status)
                this.saveTeleport(res.data.deliveryOption)
              }
              if (res.data.store_delivery_service_type === 7) {
                console.log('this.serviceType after get quotation',this.serviceType)
                if (this.serviceType.choosedService == undefined){
                    if (res.data.servicePartners.length == 0){
                        this.dialogMessage('Oops, the location is currently out of delivery partner coverage area. Please check the address respectively or try another location again.',false)
                    } else {
                        this.serviceType.servicePartners = res.data.servicePartners;
                        this.serviceType.etaInMinute = res.data.etaInMinute
                        this.requested = true;
                        this.isSubmit = true;
                    }
                } else {
                    console.log('user is login after choose service',this.user_islogin)
                    this.saveDelyva(res.data.deliveryOption)
                    this.dialogMessage(res.msg, res.status)
                }
              }
              if (res.data.store_delivery_service_type === 8) {
                console.log('this.serviceType after get quotation',this.serviceType)
                if (this.serviceType.choosedService == undefined){
                    if (res.data.servicePartners.length == 0){
                        this.dialogMessage('Oops, the location is currently out of delivery partner coverage area. Please check the address respectively or try another location again.',false)
                    } else {
                        this.serviceType.servicePartners = res.data.servicePartners;
                        this.serviceType.etaInMinute = res.data.etaInMinute
                        this.requested = true;
                        this.isSubmit = true;
                    }
                } else {
                    console.log('user is login after choose service',this.user_islogin)
                    this.saveTadago(res.data.deliveryOption)
                    this.dialogMessage(res.msg, res.status)
                }
              }
        } else {
            this.current_address_id = 0
            this.dialogMessage(res.msg, false)
        }
      }).catch(error => {
        this.current_address_id = 0
        this.dialogMessage('超出配送范围啦', false)
        this.requested = true
      })
    },
    cancelSave() {
      this.isSubmit=false;
    },
    //This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
    calcCrow(lat1, lon1, lat2, lon2) 
    {
      var R = 6371; // km
      var dLat = this.toRad(lat2-lat1);
      var dLon = this.toRad(lon2-lon1);
      var dlat1 = this.toRad(lat1);
      var dlat2 = this.toRad(lat2);

      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(dlat1) * Math.cos(dlat2); 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      var d = R * c;
      return d;
    },

    // Converts numeric degrees to radians
    toRad(Value) 
    {
        return Value * Math.PI / 180;
    },
    addAddress () {
      this.current_address_id = 0
      this.saveCurrentAddress({})
      const url = {
        path: "/user/addressDetail",
        query: { mobile: this.mobile, "address_id": 0, "is_login": true }
      };
      this.$router.push(url);
    },
    addressDetail (addressItem) {
      this.current_address_id = addressItem.address_id
      this.saveCurrentAddress(addressItem)
      const url = {
        path: "/user/addressDetail",
        query: { mobile: this.mobile, "address_id": addressItem.address_id }
      };
      this.$router.push(url)
    }
  }
};
</script>
<style lang="less">
@import url('../../assets/css/common.less');
body {
  background-color: #eeeeee;
}
.bgRed {
  background-color: @red !important;
}
.container {
  .address-list {
    text-align: left;
    padding-top: 37px;
    .selected {
      // border: 1px solid @red;
      background: #eadcdc !important;
    }
    .address-item {
      background-color: white;
      padding: 8px;
      margin: 0 0 15px 0;
      display: flex;
      align-items: center;
      .address-data {
        font-size: 14px;
        .address-info {
          font-weight: bold;
          margin-bottom: 10px;
          .default-address {
            // color: @red;
            color: @main;
          }
        }
        .address-contact {
          .contact-info {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            margin-right: 10px;
          }
        }
      }
      .addresss-wapper {
        flex-basis: 20px;
        margin-left: 10px;
      }
    }
  }
}
  .hideVisibility {
    z-index: -1;
  }

  .showVisibility {
    z-index: 1;
  }
</style>